
  import { Component, Watch } from 'vue-property-decorator'
  import GTextarea from '@/components/core/input/GTextarea.vue'
  import PTitle from '@/components/config/PTitle.vue'
  import { GenioView } from './GenioView'
  import GCostField from '@/components/core/input/GCostField.vue'

@Component({
  components: { PTitle, GTextarea, GCostField },
})
  export default class ConfigReserve extends GenioView {
    formData = {
      maxDays: 5,
      minValue: 250000,
      reserve_letter: {
        warranty: {
          list: [
            'No se aprueba el financiamiento.',
            'No se mantiene el valor ofrecido por el vehículo.',
            'Nuestro vehículo no está en las condiciones informadas.',
          ],
          text: 'Reembolso del abono si:',
        },
        compromise: {
          text: 'Por la presente, declaro mi intención de comprar el vehículo aquí individualizado y renuncio a la devolución de la presente reserva en caso de no concretar en la fecha acordada.',
        },
      },
    }

    async save () {
      if (!this.$refs.form.validate()) {
        await this.setFieldError()
        return
      }

      const fields = {
        id: this.process.id,
        config: {
          ...this.process.config,
          maxDays: parseInt(this.formData.maxDays.toString()),
          minValue: parseInt(this.formData.minValue.toString()),
          reserve_letter: {
            warranty: {
              list: this.formData.reserve_letter.warranty.list,
              text: this.formData.reserve_letter.warranty.text,
            },
            compromise: {
              text: this.formData.reserve_letter.compromise.text,
            },
          },
        },
      }

      await this.updateProcess(fields)

      this.$emit('update')
    }

    addReserveWarranty () {
      this.formData.reserve_letter.warranty.list.push('')
    }

    removeReserveWarranty (index: number) {
      this.formData.reserve_letter.warranty.list.splice(index, 1)
    }

    @Watch('process', { immediate: true, deep: true })
    onConfigChange (newValue: any) {
      if (newValue?.config) {
        this.formData = {
          maxDays: newValue?.config?.maxDays,
          minValue: newValue?.config?.minValue,
          reserve_letter: {
            warranty: {
              list: newValue?.config?.reserve_letter?.warranty?.list,
              text: newValue?.config?.reserve_letter?.warranty?.text,
            },
            compromise: {
              text: newValue?.config?.reserve_letter?.compromise?.text,
            },
          },
        }
      }
    }
  }
